import QuestionConfig from 'models/question'
import { countWords, getAverage, getRankingPopularity, uuidv4 } from './helpers'
import QuestionContext from 'models/question-context'

export const defaultQuestion = (
	parentId: string,
	context: QuestionContext
): QuestionConfig => {
	return {
		id: '',
		type: 'select',
		title: 'Type here your question',
		listPosition: 1,
		parentId: parentId, // very important
		context: context, // very important
		options: {
			required: true,
			items: [
				{
					id: uuidv4(),
					label: 'Option 1',
					value: 'option1',
					listPosition: 1,
				},
				{
					id: uuidv4(),
					label: 'Option 2',
					value: 'option2',
					listPosition: 2,
				},
			],
			min: 1,
			max: 4,
			minLabel: 'Strongly disagree',
			maxLabel: 'Strongly agree',
		},
	}
}

export const getRankingAnswersInfo = (answersForQuestion, rankingItems) => {
	return rankingItems
		.map((rankingItem: any) => {
			let rankingPositions = []
			let itemInRankingCount = 0

			for (let i = 0; i < answersForQuestion.length; i++) {
				const answer: any = answersForQuestion[i]
				const index = answer.attributes.answer.indexOf(rankingItem.id)
				if (index > -1) {
					itemInRankingCount++
					rankingPositions.push(index + 1)
				}
			}

			const averagePosition =
				rankingPositions.length > 0 ? getAverage(rankingPositions) : null

			const pFactor = getRankingPopularity(
				answersForQuestion,
				itemInRankingCount,
				averagePosition
			)

			return {
				...rankingItem,
				averagePosition,
				timesAnswered: itemInRankingCount,
				popularity: Math.round(pFactor * 10) / 10,
			}
		})
		.sort((a, b) => {
			if (a.averagePosition == 'null' && b.averagePosition !== 'null') {
				return 1
			} else {
				return -1
			}
		})
		.sort((a, b) => {
			if (a.popularity > b.popularity) {
				return -1
			} else if (a.popularity == b.popularity) {
				return 0
			} else {
				return 1
			}
		})
}

export const answersValid = ({
	requiredQuestions,
	answers,
}: {
	requiredQuestions: any[]
	answers: {} | any[]
}) => {
	//TRUE = no required questions OR answers are assigned to individual questions
	const answersArray = Array.isArray(answers) ? answers : Object.values(answers)

	return (
		requiredQuestions.length === 0 ||
		requiredQuestions.every((q: any) => {
			//Answer check
			const exists = answersArray.find((a: any) => a.questionId === q.id)
			const isRequired: boolean = q.options.required
			const type = q.type

			if (!exists && type !== 'text')
				//Allow type "text" answers that arent assigned yet
				return false

			if (type === 'text') {
				const belowLimit =
					countWords(exists?.answer ?? '') <= q.options.maxWords
				const hasLength = exists?.answer?.length > 1
				return isRequired ? hasLength && belowLimit : belowLimit
			}
			if (type === 'select.multi' || Array.isArray(exists.answer)) {
				return isRequired ? exists?.answer?.length > 0 : true // in case of multiple answers
			} else if (type === 'select') {
				return isRequired ? exists?.answer !== '' : true
			}

			return exists
		})
	)
}
